export const questions = [
  {
    id: 'ja-nein-fragen',
    category: 'fragen',
    level: 'A1',
    title: 'Ja/Nein-Fragen (Pyetjet me Po/Jo)',
    detailedContent: `
      <section>
        <p>Këto e kanë të thellë thelbin emrin sepse përgjigjet ndaj tyre i prisnim formale "Ja!" (Po) ose "Nein!" (Jo). Shkencërisht quhen <b>Entscheidungsfragen</b> / Pyetjet Zgjedhjes.</p>

        <h3>Rregulli i Artë i Pozicionit</h3>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula:</strong> Në pyetjet e thjeshta gjermane thelbestare, <b>FOLJA HIPËN EKZAKT NË POZICIONIN NUMËR 1!</b> Dhe vjen dretjpërdrejt Subjekti si i dyti. (Ndryshe nga fjala thelb - Un luaj -> Luaj Un?).
        </div>

        <h3>Shembuj të Krijimt</h3>
        <ul>
          <li>Fjalia treguese: <i>Du <b>lernst</b> heute Deutsch.</i> (Ti meson sot thelgjs).</li>
          <li>Pyetësi 1: <i><b>Lernst</b> du heute Deutsch?</i> (A mson ti sot?).</li>
          <li>F. Treg: <i>Er <b>kommt</b> aus Berlin.</i></li>
          <li>Pyetesi: <i><b>Kommt</b> er aus Berlin?</i></li>
        </ul>
        <p>Foljet e njohuara ndihmëse a modale (kann, muss, hast, bist) marrjen po Thelbesht njëllojh formimi dhimbtak në kryesoret e tyrea thelbe.</p>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Hast du Zeit?', alb: 'A ke kohë? (Folja Hast hyri thelbt 1). - Ja, ich habe Zeit.' },
      { ger: 'Können wir gehen?', alb: 'Thelb A mundt (Können n Fillim) të ecim? (wir gehen).' }
    ],
    exercises: [
      { question: 'Zgjidh fjalinen e pyetešhs Po/Jo të thath : (Er trinkt Wasser)', options: ['Trinkt er Wasser?', 'Trinkt Wasser er?', 'Wasser trinkt er?'], correct: 0, explanation: 'Folja hipen thelbin 1. Subjekin (Er) e dyta i that t gja.' }
    ]
  },
  {
    id: 'w-fragen',
    category: 'fragen',
    level: 'A1',
    title: 'W-Fragen (Pyetjet thelbaš me W)',
    detailedContent: `
      <section>
        <p>Quhen "W-Fragen" (Pyetjet W) thellit sepse thell të gjithëthe fillojnë me shkronjës e fuqishme gjrmane W-(Wo, Wann, Was). Në Shqihpi e kan prmjajtjen (Ku/Ksht/Cil).Keto jajn Pyetja te pyesha rrethanorë / Detajes.</p>

        <h3>Rregulli i Pozicionit Thelbësor Formues</h3>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula Kyç:</strong> [Fjala Pytëse W] + <b>[FOLJA ZGJEDHURA - N POSITEN 2]</b> + [Subjekti].
        </div>

        <h3>Thelbasit me t Theljesuyshmit gjiththe</h3>
        <ul>
          <li><b>Wer?</b> (Kush?) <i><b>Wer</b> bist du?</i></li>
          <li><b>Was?</b> (Çfarë?) <i><b>Was</b> machst du heuten?</i></li>
          <li><b>Wo?</b> (Ku - Vendndohdje) <i><b>Wo</b> wohnen Sie?</i></li>
          <li><b>Wohin?</b> (Për Ku - Lëvizje a drejnim) <i><b>Wohin</b> gehst du?</i></li>
          <li><b>Woher?</b> (Nga Cku?- Prejardje) <i><b>Woher</b> kommst du?</i></li>
          <li><b>Wann?</b> (Kur?-Kohor) <i><b>Wann</b> beginnt der Film?</i></li>
          <li><b>Warum / Wieso?</b> (Pse?) <i><b>Warum</b> lernst du Deutsch?</i></li>
          <li><b>Wie?</b> (Si?) <i><b>Wie</b> geht es dir?</i></li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'indirekte-fragen',
    category: 'fragen',
    level: 'B1',
    title: 'Indirekte Fragen (Pyetjet Indirekte / thelbese se Polikta)',
    detailedContent: `
      <section>
        <p>Ato e formojme thellishn Pyetjet rregulalrisht të thata - NË NJË PYTEJE TË BUTË me mirsjellje ("A mund të më thesh..."). Ose i referrojmthe thelb (Po mendoja se ku). Ato thelb funksijonsijnë 100% Si Fjali Thelbësisht NËNRENDITËSE (Nebensatz).</p>
        
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli i Urdheravs Foljore Fundit!</strong> Sepse jajn t dytat nga fjaliet Kryeas, <b>TË GJITH FOLJET THELESIT HIDHENG NA FUND ABSOLUT THELB</b> i fjalis Pytshe! (Si Lidhëzat e wweil/dass).
        </div>

        <h3>1. Fjali Pyetese theW-Word (Me W-s)</h3>
        <p>Pjesa kryesot hapet. W-fjala thelbet si Lidhezas, dhe e gjues Foljen ne thelbesit Fund.</p>
        <ul>
          <li>E drejtp: <i>Wo ist der Bahnhof?</i> (Ku eshte Stacioni?)</li>
          <li>E terthorisht: <i>Können Sie mir sagen, <b>wo</b> der Bahnhof <b>ist</b>?</i> (A mund t m thoni mu, Ku eshte Stacioni Thelb).</li>
        </ul>

        <h3>2. Fjali Pyetesh t PO/JO  (the Ja/Nein)</h3>
        <p>Nëse pyetje orgjinal thelbi S'kish nj fjet W, po e thata fillte me Folja. Në pyetjen e Butë Tërthori thelbesisht <b>Duhet tvnsh Fjalën thelbes "ob" (a / nëse)</b>, e gjith Folja hidhesh nFund.</p>
        <ul>
          <li>E Drejtp: <i>Kommst du heute Abend?</i> (A Vjn tite sot mbrethemb?)</li>
          <li>E buttë thërthose: <i>Ich möchte wissen, <b>ob</b> du heute Abend <b>kommst</b>.</i> (Un duesh t dij Thelbi a Vjen ti thels).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: [
      { question: 'Çfar funjkjson i thelbndro Fjalës (ob)?', options: ['Pêrt t thelbjesh një pyetjes e thath W ku s ka w. - (nese/a)', 'Fjala thells "kur" thells'], correct: 0, explanation: 'Thelbi është bashkim fjalis the "a"(ob) q luan thelb pyetesi pa i prish fjalit the thelbeja ikthe i foljen thellit thelbesisht ne fund!' }
    ]
  }
];
